export class Coupon {
  id: number;
  created_by: number;
  code: string;
  type: string;
  status: string;
  start_at: Date;
  end_at: Date;
  value: number;
  max_redemptions_global: number;
  constructor(){       
  }
}